import type { AuthSlice } from '../bs/auth'

/**
 * Serbian overrides for the signed-out screens.
 *
 * *uspjela* → *uspela* twice, and *vrijedi* → *važi*. Everything else on these
 * screens carries no jat and is shared with Bosnian.
 */
export const auth: Partial<AuthSlice> = {
  'login.failed': 'Prijava nije uspela.',

  'login.twoFactor.failed': 'Potvrda nije uspela.',
  'login.twoFactor.recoveryCode.hint':
    'Jedan od kodova koje ste sačuvali pri uključivanju zaštite. Važi samo jednom.',
  // *pročitana* is shared; *prijavljujemo* too — only *treba kliknuti* differs
  // in nothing, so the hint is the one line that moves.
  'login.reader.hint': 'Ako je čitač priključen, samo provucite karticu — ništa ne treba da kliknete.',
}
